import React from 'react';

const ViewLoading = () => {
  return (
    <div className="loadingio-spinner-disk-t91u3fc0s3a">
      <div className="ldio-4b7yfm6o2ot">
        <div>
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
  );
};

export default ViewLoading;
